import renewalApplications from "./renewalApplications";

const renewalApplicationService = [
    {
        matcher: 'renewalApplications',
        reply: config => {
            return [200, renewalApplications];
        }
    },
    {
        matcher: /renewalApplications\/(.*)/,
        reply: config => {
            const id = /renewalApplications\/(.*)/.exec(config.url)[1];
            const renewalApplication = renewalApplications.find(renewalApplication => renewalApplication.uuid === id);
            return [200, renewalApplication];
        }
    }
]

export default renewalApplicationService;